import { useFetchPatientReferral } from '@/api/hooks/useFetchPatientReferral'
import { analytics } from '@/lib/analytics'
import { Button, ButtonText } from '@/ui/core/button'
import { VStack } from '@/ui/core/stack'
import { Text } from '@/ui/core/typography'
import { cn } from '@/ui/utils'
import * as Clipboard from 'expo-clipboard'
import { Image } from 'expo-image'
import { useState } from 'react'
import { Platform, View, useWindowDimensions } from 'react-native'
import { Share } from 'react-native'
import Images from '#/assets/images/image-map'

const COPIED_TIMEOUT = 4000

const DesktopReferralImage = () => (
	<View className="w-[60%]">
		<Image
			style={{ height: '100%', width: '100%' }}
			source={Images.HomeReferralSplashLarge}
			contentFit="contain"
			contentPosition={'top right'}
		/>
	</View>
)

const MobileReferralImage = () => (
	<View className="w-[50%]">
		<Image
			style={{ height: '100%', width: '100%' }}
			source={Images.HomeReferralSplash}
			contentFit="cover"
			contentPosition={'top right'}
		/>
	</View>
)

const ReferralImage = () => {
	const { width: windowWidth } = useWindowDimensions()

	return windowWidth > 800 ? <DesktopReferralImage /> : <MobileReferralImage />
}

export const ReferralImageCTA = () => {
	const [isCopied, setIsCopied] = useState(false)
	const { hasRenderableReferral, referralUrl } = useFetchPatientReferral()

	const shareReferralUrl = async () => {
		if (Platform.OS === 'android' || Platform.OS === 'ios') {
			await Share.share({
				title: 'Check this out!',
				message: `Join wally today! ${referralUrl}`,
			})
		} else {
			copyReferralUrlToClipboard()
		}
	}

	const copyReferralUrlToClipboard = async () => {
		await Clipboard.setStringAsync(referralUrl)

		setIsCopied(true)

		setTimeout(() => {
			setIsCopied(false)
		}, COPIED_TIMEOUT)
	}

	const onReferralPressed = async () => {
		await shareReferralUrl()
		analytics.trackClick('home-page-referral')
	}

	return (
		<>
			{hasRenderableReferral && (
				<View className="flex-row w-full flex-1 h-full max-h-56 lg:max-h-64 bg-palette_3">
					<VStack
						className={cn(
							'w-[50%] h-full items-start justify-center pl-[10%] z-10',
							!hasRenderableReferral ? 'invisible' : 'visible'
						)}
						gap={24}
					>
						<Text className="text-splash_image lg:max-w-max max-w-40 lg:text-xl text-lg text-palette_6">
							Invite a friend and you both get $25.
						</Text>
						<Button onPress={onReferralPressed} variant="ghost">
							<ButtonText className="text-sm">
								{isCopied ? 'Copied!' : 'Share Invite'}
							</ButtonText>
						</Button>
					</VStack>
					<ReferralImage />
				</View>
			)}
		</>
	)
}
